{
  "notifications": {
    "title": "通知",
    "markAllRead": "全部标为已读",
    "viewAll": "查看所有通知",
    "empty": "没有通知",
    "emptyDescription": "您已全部了解！",
    "new": "新",
    "today": "今天",
    "yesterday": "昨天",
    "earlier": "更早",
    "justNow": "刚刚",
    "minutesAgo": "{{count}}分钟前",
    "minutesAgo_plural": "{{count}}分钟前",
    "hoursAgo": "{{count}}小时前",
    "hoursAgo_plural": "{{count}}小时前",
    "daysAgo": "{{count}}天前",
    "daysAgo_plural": "{{count}}天前",
    "categories": {
      "status_change": "状态更新",
      "correspondence": "往来信件",
      "deadline": "截止日期",
      "approval_needed": "需要审批",
      "filing_complete": "申报完成",
      "new_filing": "新申报",
      "office_action": "官方通知",
      "system": "系统"
    },
    "urgency": {
      "low": "低",
      "medium": "中",
      "high": "高",
      "critical": "紧急"
    },
    "actions": {
      "view": "查看",
      "dismiss": "忽略",
      "markRead": "标为已读"
    }
  }
}
